import ResizeIframe from "./ResizeIframe";
import Slideshow from "./Slideshow";

export default {
  ResizeIframe,
  Slideshow,
};
